import { dateToolTip } from './toolTipFormatter'
import HT from 'highcharts/highcharts-more'
import Highcharts from 'highcharts'
import moment from 'moment'
HT(Highcharts)
const areaChartOptions = (data,
  chartName = '',
  ) => {
  return {
    title: {
      text: chartName,
    },

    xAxis: {
      type: 'datetime',
      labels: {
        align:'right',
        x:-20,

        // x: -40,
        formatter: function () {
          // Subtract 1 day from the actual date in this.value to show the x-axis compatible with the data on the trend
          return Highcharts.dateFormat('%b %e', this.value - (86400000*2))
        },
        style: {
          fontSize: '12px',
          fontWeight: '400',
          color: '#4B4D4F',
          
        },
      },
    },

    yAxis: {
      
      min: 0,
      title: {
        text: 'Count',
        style: {
          color: Highcharts.getOptions().colors[1],
          fontSize: '14px',
        },
      },
     
      labels: {
        style: {
          fontSize: '16px',
          fontWeight: '400',
          color: '#4B4D4F',
        },
      },
    },

    tooltip: {
      crosshairs: true,
      shared: true,
      useHTML: true,
      padding: 0,
      formatter: dateToolTip,
    },
    credits: {
      enabled: false,
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true,
        },
      },
    },
    series: data,
  }
  }
export default areaChartOptions
